import { render } from "./IndonesiaPage.vue?vue&type=template&id=630be681&scoped=true"
import script from "./IndonesiaPage.vue?vue&type=script&lang=js"
export * from "./IndonesiaPage.vue?vue&type=script&lang=js"

import "./IndonesiaPage.vue?vue&type=style&index=0&id=630be681&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630be681"]])

export default __exports__